import React from 'react';
import { Locale } from '../../../../localization/LocalizationKeys';
import { LinkColumn } from '../../../components/Table/utils';
import { linkFieldConfig } from '../../person/fields/utils/personFieldsUtils';
import { SitePersonCriteriaOrder } from '../../../../gql/typings';

export const linkLastNameFieldConfig = linkFieldConfig(
  'lastName',
  [
    'id',
    'person.id',
    'person.lastName',
  ],
  ({ localization, openInNewTab }) => ({
    title: localization.formatMessage(Locale.Attribute.Last_name),
    additionalTableConfig: {
      width: 150
    },
    sorting: {
      ascend: [SitePersonCriteriaOrder.PERSON_LASTNAME_ASC],
      descend: [SitePersonCriteriaOrder.PERSON_LASTNAME_DESC],
    },
    render: (record) => <LinkColumn
      text={record.person.lastName}
      url={`/hcp/${record.person.id}`}
      openInNewTab={openInNewTab}
    />,
  })
);

